export const getUserName = (name: string, surname: string, patronymic: string): string => {
	let result = '';
	if (surname) result += surname;
	if (name) result += ` ${name}`;
	if (patronymic) result += ` ${patronymic}`;
	return result;
};

export const getValueWithPlusOrMinus = (value: string | number) => {
	if (`${value}`.startsWith('-') || value == '0') {
		return value;
	} else return `+${value}`;
};

export const getColorByValue = (value: string | number) => {
	return value === 0 ? 'var(--gray-5)' : `${value}`?.includes('-') ? 'var(--red-5)' : 'var(--primary-2)';
};

export const lightenColor = (color: string, percent: number): string => {
	// Convert to RGB if needed
	let r: number = 0,
		g: number = 0,
		b: number = 0;

	if (color.startsWith('#')) {
		// Handle #RGB and #RRGGBB
		const hex = color.slice(1);
		if (hex && hex.length === 3) {
			if (hex[0] !== undefined) r = parseInt(hex[0] + hex[0], 16);
			if (hex[1] !== undefined) g = parseInt(hex[1] + hex[1], 16);
			if (hex[2] !== undefined) b = parseInt(hex[2] + hex[2], 16);
		} else if (hex && hex.length === 6) {
			r = parseInt(hex.substring(0, 2), 16);
			g = parseInt(hex.substring(2, 4), 16);
			b = parseInt(hex.substring(4, 6), 16);
		}
	} else if (color.startsWith('rgb')) {
		const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
		if (!match) throw new Error('Invalid RGB');
		[, r = 0, g = 0, b = 0] = match.map(Number);
	} else {
		throw new Error('Unsupported color format');
	}

	// Convert RGB to HSL
	const hsl: [number, number, number] = rgbToHsl(r, g, b);

	// Lighten by increasing L (clamped to 0–100)
	if (hsl[2] !== undefined) {
		hsl[2] = Math.min(100, hsl[2] + percent);
	}

	// Convert back to RGB
	const [newR, newG, newB] = hslToRgb(...hsl);

	// Return as hex
	return `#${Math.round(newR).toString(16).padStart(2, '0')}${Math.round(newG).toString(16).padStart(2, '0')}${Math.round(newB).toString(16).padStart(2, '0')}`;
};

function rgbToHsl(r: number, g: number, b: number): [number, number, number] {
	(r /= 255), (g /= 255), (b /= 255);
	const max = Math.max(r, g, b),
		min = Math.min(r, g, b);
	let h: number | undefined,
		s: number,
		l = (max + min) / 2;
	if (max === min) {
		h = s = 0; // achromatic
	} else {
		const d = max - min;
		s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
		switch (max) {
			case r:
				h = (g - b) / d + (g < b ? 6 : 0);
				break;
			case g:
				h = (b - r) / d + 2;
				break;
			case b:
				h = (r - g) / d + 4;
				break;
		}
		h! /= 6;
	}
	return [Math.round(h! * 360), Math.round(s * 100), Math.round(l * 100)];
}

function hslToRgb(h: number, s: number, l: number): [number, number, number] {
	h /= 360;
	s /= 100;
	l /= 100;
	let r: number, g: number, b: number;
	if (s === 0) {
		r = g = b = l; // achromatic
	} else {
		const hue2rgb = (p: number, q: number, t: number): number => {
			if (t < 0) t += 1;
			if (t > 1) t -= 1;
			if (t < 1 / 6) return p + (q - p) * 6 * t;
			if (t < 1 / 2) return q;
			if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
			return p;
		};
		const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
		const p = 2 * l - q;
		r = hue2rgb(p, q, h + 1 / 3);
		g = hue2rgb(p, q, h);
		b = hue2rgb(p, q, h - 1 / 3);
	}
	return [r * 255, g * 255, b * 255];
}
